import { NavLink } from "react-router";
import { useContent } from "../../hooks/useContent";
import { uploadsAbsoluteUrl } from "../../utils/uploadsBase";
import styles from "./Home.module.css";

const Home = () => {
  const { t } = useContent();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

  const getImagePath = (key, fallback) => {
    const path = t(key, fallback);
    if (!path) return fallback;
    const s = String(path);
    if (s.startsWith("http://") || s.startsWith("https://")) return s;
    if (s.startsWith("/uploads")) return uploadsAbsoluteUrl(s, API_URL);
    return s || fallback;
  };

  const publicUrl = process.env.PUBLIC_URL || "";
  const defaultHeroBg = `${publicUrl}/Images/hero-image.png`;
  const heroRaw = t("home.hero.backgroundImage", "").trim();
  let heroBgUrl = defaultHeroBg;
  if (heroRaw) {
    if (heroRaw.startsWith("http://") || heroRaw.startsWith("https://")) {
      heroBgUrl = heroRaw;
    } else if (heroRaw.startsWith("/uploads")) {
      heroBgUrl = uploadsAbsoluteUrl(heroRaw, API_URL);
    } else {
      heroBgUrl = heroRaw.startsWith("/") ? `${publicUrl}${heroRaw}` : heroRaw;
    }
  }

  const heroBgCss = `url('${String(heroBgUrl).replace(/'/g, "%27")}')`;

  return (
    <div className={styles.container}>
      {/* <Navbar/> */}
      <div
        className={styles.hero}
        style={{ "--hero-bg": heroBgCss }}
      >
        <h1>{t("home.hero.title", "innovate with advaes")}</h1>
        <p>
          {t(
            "home.hero.subtitle",
            "Present the latest developments in applied science"
          )}
        </p>
        <div className={styles.buttons}>
          <NavLink
            to={t("home.hero.journalLink", "/about-journal")}
          >
            <button type="button" className={styles.btn2}>
              {t("home.hero.journalText", "About journal")}
            </button>
          </NavLink>
          <NavLink
            to={t("home.hero.conferenceLink", "/about-conference")}
          >
            <button type="button" className={styles.btn2}>
              {t("home.hero.conferenceText", "About Conference")}
            </button>
          </NavLink>
        </div>
      </div>
      <div className={styles.main}>
        <div className={styles.mainLeft}>
          <h2>{t('home.main.title', 'Shaping the future of applied sciences')}</h2>
          <p>
            {t('home.main.description', 'AdvAES focuses on driving progress in applied engineering sciences through a prestigious peer- reviewed journal and a prominent international conference. Located in Berlin, we present groundbreaking research and innovative solutions that tackle today\'s engineering challenges. Our key areas include sustainable energy systems, renewable sources, advanced materials, and digital technologies. We cater to researchers, practitioners, and industry professionals, emphasizing real-world applications that foster productivity and sustainable development in industrial processes')}
          </p>
          <NavLink to={t('home.main.button.link', '/contact')}>
            <button type="button" className={styles.btn3}>
              {t('home.main.button.text', 'Get in touch')}
            </button>
          </NavLink>
        </div>ячё
        <div className={styles.mainRight}>
          <img
            src={getImagePath('home.main.image', '/Images/Hero.jpg')}
            alt={t('home.main.image.alt', 'Conference')}
          />
        </div>
      </div>
      <div className={styles.aboutUs}>
        <h2>{t('home.about.title', 'About us')}</h2>
        <p>
          {t('home.about.description', 'The Advances in Applied Engineering Sciences" encompasses both a prestigious peer-reviewed journal and a leading international conference, dedicated to the latest advancements and practical innovations in applied engineering sciences. Both the journal and the conference aim to present and discuss research that offers cutting-edge solutions to pressing engineering and technological challenges, supporting both theoretical progress and the practical application of engineering solutions. Key areas of focus include sustainable energy systems, renewable energy sources, advanced materials, digital technologies, mechanical and transportation systems, and the development of human capital in engineering. Catering to a broad readership and audience, including researchers, practitioners, and industry professionals, both the journal and the conference emphasize real-world applications of innovations that enhance productivity and promote the sustainable development of industrial processes. "Advances in Applied Engineering Sciences" is committed to maintaining high standards of peer review and to publishing and presenting impactful research that helps shape the future of applied engineering.')}
        </p>

        <NavLink to={t('home.about.button.link', '/about-us')}>
          <button type="button" className={styles.btn3}>
            {t('home.about.button.text', 'Read more')}
          </button>
        </NavLink>
      </div>

      {/* Invitation Section */}

      <div className={styles.invitationSection}>
        <div className={styles.invitationContent}>
          <div className={styles.invitationText}>
            <h2 className={styles.invitationTitle}>
              {t('home.invitation.title', 'Invitation to the International Scientific Conference in Tashkent!')}
            </h2>
            <h3 className={styles.invitationSubtitle}>
              {t('home.invitation.subtitle', 'Discover New Horizons in Science and Innovation!')}
            </h3>
            <p className={styles.invitationDescription}>
              {t('home.invitation.description', 'In June 2025, Tashkent, Uzbekistan, will become a hub for scientists and researchers from around the world. We invite you to participate in our prestigious International Scientific Conference, dedicated to the most pressing issues in Advances in Applied Engineering Sciences (AdvaES 2025).')}
            </p>
          </div>
          <div className={styles.invitationImage}>
            <img
              src={getImagePath('home.invitation.image', '/Images/utas-1.jpg')}
              alt={t('home.invitation.image.alt', 'Tashkent City')}
              className={styles.cityImage}
            />
          </div>
        </div>
      </div>

      {/* Participation Formats Section */}
      <div className={styles.participationSection}>
        <h2 className={styles.participationTitle}>
          {t('home.participation.title', 'Two Participation Formats to Choose From:')}
        </h2>

        <div className={styles.formatsGrid}>
          {/* In-Person Participation */}
          <div className={styles.formatCard}>
            <div className={styles.cardHeader}>
              <svg
                className={styles.headerIcon}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              <div>
                <div className={styles.formatTitle}>{t('home.participation.inperson.title', 'In-Person')}</div>
                <div className={styles.formatTitle}>{t('home.participation.inperson.subtitle', 'Participation:')}</div>
              </div>
            </div>

            <div className={styles.cardContent}>
              <div className={styles.benefit}>
                <h3 className={styles.benefitTitle}>{t('home.participation.inperson.benefit1.title', 'Present Your Research:')}</h3>
                <p className={styles.benefitText}>
                  {t('home.participation.inperson.benefit1.text', 'Showcase your scientific work at the conference in Tashkent, Uzbekistan.')}
                </p>
              </div>

              <div className={styles.benefit}>
                <h3 className={styles.benefitTitle}>
                  {t('home.participation.inperson.benefit2.title', 'Engage in Live Discussions:')}
                </h3>
                <p className={styles.benefitText}>
                  {t('home.participation.inperson.benefit2.text', 'Connect with colleagues from various countries.')}
                </p>
              </div>

              <div className={styles.benefit}>
                <h3 className={styles.benefitTitle}>
                  {t('home.participation.inperson.benefit3.title', 'Gain an Unforgettable Experience:')}
                </h3>
                <p className={styles.benefitText}>
                  {t('home.participation.inperson.benefit3.text', 'Immerse yourself in an atmosphere of scientific collaboration and idea exchange.')}
                </p>
              </div>
            </div>
          </div>

          {/* Remote Participation */}
          <div className={styles.formatCard}>
            <div className={styles.cardHeader}>
              <svg
                className={styles.headerIcon}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                <line x1="8" y1="21" x2="16" y2="21"></line>
                <line x1="12" y1="17" x2="12" y2="21"></line>
              </svg>
              <div>
                <div className={styles.formatTitle}>{t('home.participation.remote.title', 'Remote Participation')}</div>
                <div className={styles.formatTitle}>{t('home.participation.remote.subtitle', '(Publication Only):')}</div>
              </div>
            </div>

            <div className={styles.cardContent}>
              <div className={styles.benefit}>
                <h3 className={styles.benefitTitle}>
                  {t('home.participation.remote.benefit1.title', 'Publish Without Attending:')}
                </h3>
                <p className={styles.benefitText}>
                  {t('home.participation.remote.benefit1.text', 'Get your article published in our reputable scientific journal.')}
                </p>
              </div>

              <div className={styles.benefit}>
                <h3 className={styles.benefitTitle}>
                  {t('home.participation.remote.benefit2.title', 'Reach a Global Audience:')}
                </h3>
                <p className={styles.benefitText}>
                  {t('home.participation.remote.benefit2.text', 'Thousands of readers worldwide will access your research.')}
                </p>
              </div>

              <div className={styles.benefit}>
                <h3 className={styles.benefitTitle}>
                  {t('home.participation.remote.benefit3.title', 'High-Impact Publication:')}
                </h3>
                <p className={styles.benefitText}>
                  {t('home.participation.remote.benefit3.text', 'The journal is indexed in leading scientific databases.')}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Important Dates */}
        <div className={styles.datesSection}>
          <div className={styles.datesColumn}>
            <h3 className={styles.datesTitle}>
              {t('home.dates.inperson.title', 'Important Dates for In-Person Participation:')}
            </h3>

            <div className={styles.datesGrid}>
              {(t('home.dates.inperson.items', []) || []).slice(0, 12).map((it, idx) => (
                <div key={idx} className={styles.dateCard}>
                  <div className={styles.dateLabel}>
                    {it?.label || ''}
                  </div>
                  <div className={styles.dateValue}>{it?.value || ''}</div>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.datesColumn}>
            <h3 className={styles.datesTitle}>
              {t('home.dates.remote.title', 'Important Dates for Remote Participation:')}
            </h3>

            <div className={styles.datesGrid}>
              {(t('home.dates.remote.items', []) || []).slice(0, 12).map((it, idx) => (
                <div key={idx} className={styles.dateCard}>
                  <div className={styles.dateLabel}>
                    {it?.label || ''}
                  </div>
                  <div className={styles.dateValue}>{it?.value || ''}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Topics Section */}
      <div className={styles.topicsSection}>
        <h2 className={styles.topicsMainTitle}>{t('home.topics.title', 'Topics')}</h2>

        <div className={styles.topicsGrid}>
          {(t('home.topics.groups', []) || []).slice(0, 5).map((g, idx) => {
            const icons = [
              <polyline key="i0" points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polyline>,
              <>
                <circle cx="12" cy="12" r="10"></circle>
                <circle cx="12" cy="12" r="6"></circle>
                <circle cx="12" cy="12" r="2"></circle>
              </>,
              <>
                <circle cx="12" cy="12" r="2"></circle>
                <path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>
              </>,
              <>
                <path d="M5 12.55a11 11 0 0 1 14.08 0"></path>
                <path d="M1.42 9a16 16 0 0 1 21.16 0"></path>
                <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
                <line x1="12" y1="20" x2="12.01" y2="20"></line>
              </>,
              <>
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M12 1v6m0 6v6m9-9h-6m-6 0H3"></path>
              </>,
            ];

            const items = Array.isArray(g?.items) ? g.items : [];

            return (
              <div key={idx} className={styles.topicCard}>
                <div className={styles.topicHeader}>
                  <svg
                    className={styles.topicIcon}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    {icons[idx] || icons[0]}
                  </svg>
                  <div>
                    <div className={styles.topicTitle}>{g?.title1 || ''}</div>
                    <div className={styles.topicTitle}>{g?.title2 || ''}</div>
                  </div>
                </div>
                <ul className={styles.topicList}>
                  {items.slice(0, 12).map((txt, i) => (
                    <li key={i}>{txt}</li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        {/* Indexing Section */}
        <div className={styles.indexingSection}>
          <h2 className={styles.indexingTitle}>{t('home.indexing.title', 'Indexing and Key Information')}</h2>
          <p className={styles.indexingText}>
            {t('home.indexing.description', 'Our scientific journal is committed to the wide dissemination of scientific knowledge.')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Home;
